import React, { useState, useEffect, useRef } from 'react';
import './style.css';

import AboutUsCover from '../../assets/images/AboutUsCover.webp';

import { IoMdPlay } from 'react-icons/io';

export default function AboutUsSection() {
  const [isPlaying, setIsPlaying] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentSectionRef = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Start playing the video when the section is in view
          setIsPlaying(true);
        } else {
          setIsPlaying(false);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (currentSectionRef) {
      observer.observe(currentSectionRef);
    }

    return () => {
      if (currentSectionRef) {
        observer.unobserve(currentSectionRef);
      }
    };
  }, []);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <>
      <div className='about-us-section'>
        <h2 className='section-title'>About Starllife Group</h2>
        <div className='row-section about-us-row-section'>
          <div>
            <p>
              Starlife Group is a fully integrated real estate development,
              construction, and investment firm redefining urban living through
              innovation, sustainability, and design excellence. Since 2018,
              we’ve grown into a dynamic force managing the full real estate
              lifecycle—from acquisition and development to construction,
              lending, and capital ventures.
            </p>
            <p>
              Our portfolio spans large-scale multifamily communities, mixed-use
              developments, luxury homes, townhouses, and commercial properties
              across South Florida and Europe. With a global network of partners
              and investors, we operate with both local insight and
              international reach.
            </p>
            <p>
              Headquartered in South Florida, one of the world’s most vibrant
              real estate markets, we’re uniquely positioned to lead in a region
              defined by growth, opportunity, and lifestyle. Our work combines
              thoughtful design, strategic investment, and expert execution to
              deliver high-performing, future-ready properties.
            </p>
            <p>
              At Starlife Group, we don’t just build structures—we create
              lasting value for investors, homeowners, and the communities we
              serve.
            </p>
          </div>
        </div>
      </div>
      <div className='video-container' ref={sectionRef}>
        {isPlaying ? (
          <video
            src={
              'https://pub-49d97e77b0ae42d0a47ad8443433d0fb.r2.dev/about-us.mp4'
            }
            controls
            autoPlay
            loop
            className='video-player'
          />
        ) : (
          <div className='video-cover' onClick={handlePlay}>
            <img src={AboutUsCover} alt='Video Cover' className='cover-image' />
            <button className='play-button'>
              <IoMdPlay />
            </button>
          </div>
        )}
      </div>
    </>
  );
}
